/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable no-return-assign */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { FaCalendarAlt } from '@react-icons/all-files/fa/FaCalendarAlt';
import { FaArrowDown } from '@react-icons/all-files/fa/FaArrowDown';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import { generateArray } from 'gatsby-core-theme/src/helpers/generators';
import { Context } from '~context/MainProvider';
import Leagues from './leagues';
import styles from './schedule.module.scss';

const Schedule = ({ pageContext }) => {
  const { page } = pageContext;
  const { template } = page;
  const { translations } = useContext(Context) || {};
  const tabRefs = useRef([]);
  const contentRefs = useRef([]);
  const selectLabel = useRef(null);

  const schedule = generateArray(page?.relation?.schedule);

  const getLabel = (item) => `${item?.date?.day} ${item?.date?.day_number}. ${item?.date?.month}`;

  const toggleTabs = (index) => {
    for (let i = 0; i < tabRefs.current.length; i += 1) {
      tabRefs.current[i].classList.remove(styles.active);
      contentRefs.current[i].classList.remove(styles.active);
    }
    tabRefs.current[index].classList.add(styles.active);
    contentRefs.current[index].classList.add(styles.active);
    selectLabel.current.innerText = getLabel(schedule[index]);
  };

  const handelPrev = () => {
    for (let i = 0; i < tabRefs.current.length; i += 1) {
      if (i < 6) {
        tabRefs.current[i].classList.add(styles.show);
      } else {
        tabRefs.current[i].classList.remove(styles.show);
      }
    }
  };
  const handelNext = () => {
    if (tabRefs.current.length < 7) return;
    for (let i = 0; i < tabRefs.current.length; i += 1) {
      if (i > 5) {
        tabRefs.current[i].classList.add(styles.show);
      } else {
        tabRefs.current[i].classList.remove(styles.show);
      }
    }
  };

  const handleSelect = (e) => {
    const { value } = e.target;
    toggleTabs(value);
  };

  return (
    <div className={`${styles.scheduleContainer} ${styles[template]}`}>
      <h3>{translate(translations, 'schedule2', 'Schedule')}</h3>
      <div className={styles.tabsHeaderDesktop}>
        <div className={styles.prev} onClick={() => handelPrev()}>{`<<<`}</div>
        {schedule.map((item, i) => (
          <div
            key={item?.date?.date}
            className={`${styles.tab} ${i === 0 && styles.active} ${i <= 5 && styles.show}`}
            ref={(el) => (tabRefs.current[i] = el)}
            onClick={() => toggleTabs(i)}
          >
            <span>{getLabel(item)}</span>
          </div>
        ))}
        <div className={styles.next} onClick={() => handelNext()}>{`>>>`}</div>
      </div>
      <div className={styles.tabsHeaderMobile}>
        <div className={styles.select}>
          <select onChange={(e) => handleSelect(e)}>
            {schedule.map((item, i) => (
              <option key={item?.date?.date} value={i}>
                {getLabel(item)}
              </option>
            ))}
          </select>
          <span>
            <FaCalendarAlt />
            <span ref={selectLabel}>{getLabel(schedule[0])}</span>
            <FaArrowDown />
          </span>
        </div>
      </div>
      {schedule.map((item, i) => (
        <div
          key={item?.date?.date}
          className={`${styles.content} ${i === 0 && styles.active}`}
          ref={(el) => (contentRefs.current[i] = el)}
        >
          <Leagues items={generateArray(item?.tournaments)} template={template} />
        </div>
      ))}
    </div>
  );
};

Schedule.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      path: PropTypes.string,
      relation: PropTypes.shape({}),
    }),
  }).isRequired,
};

export default Schedule;
